import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import {
  generateInputField,
  generateSelectField,
} from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { createProductInvoice, editProductInvoice } from "store/actions";
import * as yup from "yup";
import { modeDetail } from "./utils";

const DetailData = props => {
  const { isOpenModal, dataDetail, toggleModal, mode } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["product"]);
  const { addToast } = useToasts();

  const productInvoice = useSelector(state => state.productInvoice);
  const { loading, data, error } = productInvoice.detailProduct;
  const { loading: loadingCreate } = productInvoice.createProduct;

  const schema = yup.object().shape({
    code: yup
      .string()
      .required(t("form.validate.required", { title: t("form.code") })),
    name: yup
      .string()
      .required(t("form.validate.required", { title: t("form.name") })),
    unit: yup
      .string()
      .required(t("form.validate.required", { title: t("form.unit") })),
    price: yup
      .number()
      .required(t("form.validate.required", { title: t("form.price") })),
    id_vat: yup.object().nullable(),
    //   .required(t("form.validate.select", { title: t("form.id_vat") })),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: { code: "", price: 0, id_vat: undefined },
  });

  useEffect(() => {
    if (isOpenModal) {
      reset();
      if (dataDetail) {
        setValue("code", dataDetail.code);
        setValue("name", dataDetail.name);
        setValue("unit", dataDetail.unit);
        setValue("price", dataDetail.price);
        let vat = productInvoice.listVat.find(
          item => Number(item.id) === Number(dataDetail.id_vat)
        );
        if (!vat && dataDetail?.vat_text) {
          vat = {
            value: dataDetail?.vat_text,
            label: dataDetail?.vat_text,
            id: null,
          };
        }
        setValue("id_vat", vat);
      }
    }
  }, [isOpenModal]);

  const onSubmit = values => {
    let data = {
      ...values,
    };
    if (values.id_vat) {
      data = {
        ...data,
        id_vat: values?.id_vat?.id,
        vat_text: values?.id_vat?.vat_text,
      };
    }
    switch (mode) {
      case modeDetail.CREATE:
        dispatch(createProductInvoice(data));
        break;
      case modeDetail.EDIT:
        dispatch(editProductInvoice(data, dataDetail.id));
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {mode === modeDetail.CREATE && `Thêm sản phẩm/ dịch vụ`}
            {mode === modeDetail.VIEW && `Chi tiết sản phẩm/ dịch vụ`}
            {mode === modeDetail.EDIT && `Cập nhật sản phẩm/ dịch vụ`}
          </ModalHeader>
          {loading ? (
            <ModalBody>
              <LoadingFormNormal
                countInput="3"
                countButton="1"
                formClass="row-cols-1 row-cols-md-2"
                buttonClass="justify-content-end"
                buttonColClass="col-3"
              />
            </ModalBody>
          ) : (
            <React.Fragment>
              <ModalBody>
                <Row className="row-cols-1 row-cols-lg-2">
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.code"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "code",
                        t("placeholder.enter", {
                          title: t("form.code"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading,
                        null,
                        control,
                        false,
                        false,
                        false,
                        null,
                        null,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.name"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "name",
                        t("placeholder.enter", {
                          title: t("form.name"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading,
                        null,
                        control,
                        false
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.unit"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "unit",
                        t("placeholder.enter", {
                          title: t("form.unit"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading,
                        null,
                        control,
                        false
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.price"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "price",
                        t("placeholder.enter", {
                          title: t("form.price"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading,
                        null,
                        control,
                        true
                      )}
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup className="mb-3">
                      {generateSelectField(
                        t("form.id_vat"),
                        false,
                        errors,
                        "id_vat",
                        t("placeholder.select", {
                          title: t("form.id_vat"),
                        }),
                        mode === modeDetail.VIEW || loading,
                        control,
                        dataDetail?.vat_text
                          ? [
                              {
                                value: dataDetail?.vat_text,
                                label: dataDetail?.vat_text,
                                id: null,
                              },
                              ...productInvoice.listVat,
                            ]
                          : productInvoice.listVat,
                        "auto",
                        null,
                        false,
                        false,
                        true
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                {mode !== modeDetail.VIEW && (
                  <Row className="justify-content-end">
                    <Col className="col-auto">
                      <Button
                        color="primary"
                        className="btn-label"
                        type="button"
                        onClick={() => {
                          handleSubmit(onSubmit)();
                        }}
                        disabled={loading}
                      >
                        <i className="bx bx-save label-icon"></i>
                        {mode === modeDetail.CREATE && t("form.save")}
                        {mode === modeDetail.EDIT && t("form.update")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </ModalFooter>
            </React.Fragment>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

DetailData.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
  mode: PropTypes.string,
};

DetailData.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
};

export default DetailData;
